export const DEFAULT_PAGE_SIZE = 50
export const MAX_VISIBLE_COLUMNS_COUNT = 6

export const EXCLUSIVE_FILTER_GROUPS = [
  [
    {
      key: 'assetIdQuery',
      label: 'Asset ID',
    },
  ],
  [
    {
      key: 'status',
      label: 'Status',
    },
  ],
]

export const PINNED_FILTERS_STORAGE_KEY = 'consignments-pinned-filters-storage'
export const TABLE_SETTINGS_STORAGE_KEY = 'consignments-table-settings-storage'

export const TABLE_COLUMNS = {
  KEY: 'key',
  DATE_RECEIVED: 'dateReceived',
  SOURCE: 'source',
  PAYOR: 'payor',
  REVIEWER: 'reviewer',
  STATUS: 'status',
} as const

export const TABLE_COLUMNS_MAP = {
  [TABLE_COLUMNS.KEY]: {
    label: 'Asset ID',
    canBeHidden: false,
  },
  [TABLE_COLUMNS.DATE_RECEIVED]: {
    label: 'Received',
    canBeHidden: true,
  },
  [TABLE_COLUMNS.SOURCE]: {
    label: 'Source',
    canBeHidden: true,
  },
  [TABLE_COLUMNS.PAYOR]: {
    label: 'Payor',
    canBeHidden: true,
  },
  [TABLE_COLUMNS.REVIEWER]: {
    label: 'Reviewer',
    canBeHidden: true,
  },
  [TABLE_COLUMNS.STATUS]: {
    label: 'Status',
    canBeHidden: false,
  },
}
